import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Coffee, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function MugWall({ className = "" }) {
  const { user } = useAuth();
  const [photos, setPhotos] = useState(null);
  useEffect(() => { if (user) api.get("/mug-gift/photos").then(({ data }) => setPhotos(data)).catch(() => setPhotos([])); }, [user]);
  if (!user || !photos) return null;
  return (
    <section className={`rounded-[2rem] bg-[#121212] text-white p-5 sm:p-6 ring-1 ring-amber-300/25 space-y-4 ${className}`} data-testid="mug-wall">
      <div className="flex items-end justify-between gap-3 flex-wrap">
        <div>
          <p className="text-[11px] font-extrabold uppercase tracking-[0.25em] text-amber-300 flex items-center gap-1.5"><Coffee className="w-4 h-4" /> Tassen-Fotowand</p>
          <h2 className="font-display text-xl sm:text-2xl font-black mt-1">Unsere Unterstützer &amp; ihre Tassen</h2>
        </div>
        <Link to="/tasse" className="text-sm font-bold text-amber-300 inline-flex items-center gap-0.5 hover:underline" data-testid="mug-wall-more">Zur Tasse <ChevronRight className="w-4 h-4" /></Link>
      </div>
      {photos.length ? (
        <ul className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          {photos.map((p, i) => (
            <li key={p.id} className="rounded-2xl overflow-hidden bg-white/5 fade-up" style={{ animationDelay: `${i * 60}ms` }} data-testid={`mug-wall-photo-${p.id}`}>
              <Link to={`/post/${p.id}`} className="block group">
                <img src={p.images[0]} alt={`Tasse von ${p.user?.name || "Mitglied"}`} className="w-full aspect-square object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
              </Link>
              <p className="px-3 py-2 text-xs font-bold truncate">{p.user?.name || "Mitglied"}</p>
            </li>
          ))}
        </ul>
      ) : <p className="text-sm text-white/60" data-testid="mug-wall-empty">Noch keine Tassen-Fotos – die ersten Unterstützer-Tassen sind bald unterwegs! ☕</p>}
    </section>
  );
}
